import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Injectable } from '@angular/core';
import { LocalizeRouterService } from 'localize-router';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ApiService, RegistrazioneRequest } from './api.service';
import { CarrelloService } from './carrello.service';
import { PreferitiService } from './preferiti.service';
import { StorageService } from './storage.service';
import { getOrigin } from '../util';


@Injectable({providedIn: 'root'})
export class AuthService {

  constructor(
    private storage: StorageService,
    private api: ApiService,
    private localize: LocalizeRouterService,
    private carrelloService: CarrelloService,
    private preferiti: PreferitiService
  ) { }

  get isLogged() {
    return this.storage.getLocal('token-stem') && this.storage.getLocal('user-stem');
  }

  get user() {
    return this.storage.getLocal('user-stem');
  }

  set user(user) {
    this.storage.setLocal('user-stem', user);
  }

  get userId() {
    return this.user ? this.user.idUtente : null;
  }

  get token() {
    return this.storage.getLocal('token-stem');
  }

  login(jsonIn: {email: string, password: string, idCarrello?: number, language?: string}): Observable<any> {
    jsonIn.idCarrello = this.storage.getLocal('carrello-stem') ? this.storage.getLocal('carrello-stem').idCarrello : null;
    jsonIn.language = this.localize.parser.currentLang.toUpperCase();
    return this.api.login(jsonIn).pipe(
      // Salvo in storage user e token
      switchMap(((res: any) => {
        if (res.esito === 'OK') {
          this.storage.setLocal('token-stem', res.result.token);
          this.storage.setLocal('user-stem', res.result);
        }
        return this.carrelloService.aggiornaCarrello().pipe(map(() => res));
      })),
      switchMap(((res) => this.preferiti.aggiornaPreferiti().pipe(map(() => res)))
    ));
  }

  logout(): Observable<any> {
    const jsonIn = { token: this.token};
    return this.api.logout(jsonIn).pipe(map(((res: any) => {
      this.svuotaStorage();
      return res;
    })));
  }

  svuotaStorage() {
    this.storage.setLocal('token-stem', null);
    this.storage.setLocal('user-stem', null);
    this.storage.setLocal('preferiti-stem', null);
    this.storage.setLocal('carrello-stem', null);
    this.carrelloService.aggiornaCarrello().subscribe();
  }

  registrazione(jsonIn: RegistrazioneRequest) {
    jsonIn.language = this.localize.parser.currentLang.toUpperCase();
    jsonIn.idCarrello = this.storage.getLocal('idCarrello');
    jsonIn.urlPaginaAttivazioneCliente = getOrigin() + this.localize.translateRoute('/area-riservata').toString() + '/confirm-registration';
    console.log(jsonIn.urlPaginaAttivazioneCliente);
    return this.api.registrazione(jsonIn);
  }

}


